import cx from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Checkbox({
  className,
  id,
  label,
  inputProps,
  labelClassName,
  ...spreadProps
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: cx('font-size-sm custom-control custom-checkbox', className),
    ...spreadProps,
    children: [/*#__PURE__*/_jsx("input", {
      ...inputProps,
      className: 'custom-control-input cursor-pointer',
      type: "checkbox",
      id: id,
      name: id
    }), /*#__PURE__*/_jsx("label", {
      className: cx('custom-control-label cursor-pointer', labelClassName),
      htmlFor: id,
      children: label
    })]
  });
}